import { locale } from "../../services/LocaleService.js";

export class SplashScreen {
    constructor(message) {
        // [FIX] Use localized default message if none provided
        this.message = message || locale.t('main.splash_loading');
        this.container = document.createElement('div');
        this.container.id = 'splash-screen';
        this.container.className = "fixed inset-0 z-50 flex items-center justify-center overflow-hidden transition-opacity duration-1000";
    }

    render() {
        this.container.innerHTML = `
            <!-- Layer 1: Background with Pulsing Brightness -->
            <div class="absolute inset-0 z-0 bg-[url('/login.webp')] bg-cover bg-center animate-bg">
                <div class="absolute inset-0 bg-black/40"></div>
            </div>

            <!-- Layer 2: Content (Logo & Text) -->
            <div class="relative z-10 flex flex-col items-center gap-8 px-4 text-center">
                <!-- Pulsing Logo -->
                <img src="/logo.png" 
                     alt="SSULWHA" 
                     class="w-48 md:w-64 drop-shadow-[0_0_15px_rgba(255,255,255,0.3)] animate-logo"
                >
                
                <!-- Loading Text -->
                <p class="text-white/90 text-sm md:text-base font-medium tracking-widest animate-pulse font-serif">
                    ${this.message}
                </p>
            </div>

            <style>
                /* Background Breathing Animation */
                @keyframes bg-breathe {
                    0%, 100% { filter: brightness(0.6) scale(1.0); }
                    50% { filter: brightness(0.8) scale(1.02); }
                }
                .animate-bg {
                    animation: bg-breathe 6s ease-in-out infinite alternate;
                }

                /* Logo Breathing Animation */
                @keyframes logo-breathe {
                    0%, 100% { 
                        transform: scale(1); 
                        opacity: 0.85; 
                        filter: drop-shadow(0 0 10px rgba(139, 92, 246, 0.3));
                    }
                    50% { 
                        transform: scale(1.05); 
                        opacity: 1; 
                        filter: drop-shadow(0 0 25px rgba(139, 92, 246, 0.6));
                    }
                }
                .animate-logo {
                    animation: logo-breathe 3s ease-in-out infinite;
                }
            </style>
        `;

        document.body.appendChild(this.container);

        // Force reflow to ensure animation starts smoothly
        void this.container.offsetWidth;
    }

    destroy() {
        this.container.classList.add('opacity-0', 'pointer-events-none');
        setTimeout(() => {
            if (this.container.parentNode) {
                this.container.parentNode.removeChild(this.container);
            }
        }, 1000); // Wait for fade out
    }
}
